import React from "react";
import { Container, Row, Col} from "react-bootstrap";
import Tick from "../../../Images/tick.png";
import './PartnerDocument.css';
function PartnerDocument(){
    return(
        <>
            <section className="document-sc">
                <Container>
                    <Row className="align-items-center">
                        <Col xs={12}>
                            <div className="document-pnl">
                                <h2 className="pageinnerhead text-center">Documents You Need to Submit</h2>
                                <div className="document-main">
                                    <div className="document-list">
                                        <img src={Tick} alt="tick" className="tick"></img>
                                        <span>Pan Card</span>
                                    </div>
                                    <div className="document-list">
                                        <img src={Tick} alt="tick" className="tick"></img>
                                        <span>Aadhar Card</span>
                                    </div>
                                    <div className="document-list">
                                        <img src={Tick} alt="tick" className="tick"></img>
                                        <span>Photographs</span>
                                    </div>
                                    <div className="document-list">
                                        <img src={Tick} alt="tick" className="tick"></img>
                                        <span>Personal Address</span>
                                    </div>
                                    <div className="document-list">
                                        <img src={Tick} alt="tick" className="tick"></img>
                                        <span>Business Address</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default PartnerDocument;